import { renderToString } from "react-dom/server";

import {
    combineConfigs,
    firstAndLastDateTicks,
    gradientConfig,
    noMarkerConfig,
    noZoomConfig,
    trendConfig,
} from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";
import dayjs from "dayjs";

import { ShareTooltip } from "app/components/ShareTooltip/ShareTooltip";
import type { BenchmarkGranularity } from "app/common/benchmark/constants";
import { chartTypes } from "app/UtilitiesAndConstants/Constants/ChartTypes";

export const defaultEmptyDataGraph = {
    data: [
        [1, 100],
        [2, 100],
        [3, 100],
        [4, 100],
        [5, 100],
        [6, 100],
    ],
};
export const getGradient = ({ disabled }: { disabled: boolean }) => {
    return disabled
        ? {
              fillColor: colorsPalettes.navigation.ACTIVE_TILE_CLICKED,
              stop1Color: colorsPalettes.bluegrey[100],
              stop2Color: "rgba(233, 241, 253, 0.2)",
          }
        : {
              fillColor: colorsPalettes.blue[400],
              stop1Color: "rgb(233, 241, 253)",
              stop2Color: "rgba(233, 241, 253, 0.2)",
          };
};

export const getBarChart = ({
    granularity,
    disabled,
    valueFormatter,
}: {
    granularity: BenchmarkGranularity;
    disabled: boolean;
    valueFormatter?: (val: number) => string;
}) => {
    const graphParams = {
        type: chartTypes.AREA,
        ...getGradient({ disabled }),
    };

    return combineConfigs(graphParams, [
        {},
        gradientConfig,
        trendConfig,
        firstAndLastDateTicks,
        noMarkerConfig,
        noZoomConfig,
        {
            chart: {
                height: 64,
            },
            tooltip: {
                enabled: !disabled,
                outside: true,
                useHTML: true,
                shadow: false,
                backgroundColor: "transparent",
                formatter() {
                    return renderToString(
                        <ShareTooltip
                            timestamp={dayjs(this.x as number).toISOString()}
                            value={this.y}
                            granularity={granularity}
                            formatter={valueFormatter}
                        />,
                    );
                },
            },
            plotOptions: {
                series: {
                    enableMouseTracking: !disabled,
                    states: {
                        hover: {
                            enabled: !disabled,
                        },
                    },
                },
            },
        },
    ]);
};
